import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FilterQuery} from '@app/tag/tag-input/tag-input.component';
import {ReplaySubject} from 'rxjs';

// after:2022/04/04
export const kAfterRegex = /after:\s?(\d{4}\/\d{1,2}\/\d{1,2})/i;
// before:2022/04/04
export const kBeforeRegex = /before:\s?(\d{4}\/\d{1,2}\/\d{1,2})/i;

export class FilterData {
    search: string;
    tags: string[];
    users: string[];
    dates: string[];
    operator: string;

    constructor(init?: Partial<FilterData>) {
        Object.assign(this, init);
    }

    serialize(): string {
        return JSON.stringify(this);
    }

    public static deserialize(value: string): FilterData {
        return new FilterData(JSON.parse(decodeURIComponent(value)));
    }

    public get isValid(): boolean {
        return Boolean(this.search || this.tags || this.users || this.dates);
    }

    public clear() {
        this.search = undefined;
        this.tags = undefined;
        this.users = undefined;
        this.dates = undefined;
    }
}

@Injectable({
    providedIn: 'root',
})
export class FilterService {
    public queryData: ReplaySubject<FilterData>;
    public filterQuery: ReplaySubject<FilterQuery>;
    private filterData: FilterData;

    constructor(
        private http: HttpClient,
        private router: Router,
        private activatedRoute: ActivatedRoute,
    ) {
        this.queryData = new ReplaySubject<FilterData>();
        this.filterQuery = new ReplaySubject<FilterQuery>();
        this.filterData = new FilterData();
    }

    clear(): void {
        const url = this.router
            .createUrlTree([], {
                relativeTo: this.activatedRoute,
            })
            .toString();
        this.router.navigateByUrl(url, { replaceUrl: true });
    }

    setFilterQuery(filterQuery: FilterQuery) {
        const filterData = new FilterData();
        if (filterQuery.search) {
            filterData.search = filterQuery.value.replace(' and ', ' AND ').replace(' or ', ' OR ');
        } else if (filterQuery.date) {
            filterData.dates = [];
            if (kAfterRegex.test(filterQuery.value)) {
                filterData.dates[0] = kAfterRegex.exec(filterQuery.value)[1];
            }
            if (kBeforeRegex.test(filterQuery.value)) {
                filterData.dates[1] = kBeforeRegex.exec(filterQuery.value)[1];
            }
        } else if (filterQuery.user) {
            filterData.users = [filterQuery.value];
        } else {
            const tagValue = filterQuery.value;
            filterData.tags = [tagValue];
        }

        this.filterData = filterData;
        this.navigate();
    }

    setFilterData(data) {
        this.filterData = new FilterData();
        Object.assign(this.filterData, data);
        this.navigate();
    }

    patchFilterData(key, value, clear: boolean = false) {
        if (clear) {
            this.filterData.clear();
        }
        if (value === null) {
            delete this.filterData[key];
        }
        else {
            this.filterData[key] = value;
        }

        if (!this.filterData.isValid) {
            this.filterData.clear();
        }

        this.navigate();
    }

    navigate() {
        const url = this.router
            .createUrlTree([], {
                relativeTo: this.activatedRoute,
                queryParams: { q: this.filterData.serialize() },
            })
            .toString();
        this.router.navigateByUrl(url, { replaceUrl: true });
    }
}
